import * as THREE from 'three';
import radarCuedObservation from '../../scenarios/radar-cued-observation.json';
import { AppShell } from './AppShell';
import { SimWorkerClient, type WorkerLike } from './simWorkerClient';

const mount = document.getElementById('app');

if (mount !== null) {
  try {
    if (!crossOriginIsolated) {
      throw new Error(
        'Simulation worker needs SharedArrayBuffer and cross-origin isolation; serve with COOP/COEP headers.',
      );
    }
    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.shadowMap.enabled = true;

    const shell = new AppShell({
      document,
      storage: window.localStorage,
      scenarios: { 'radar-cued-observation': radarCuedObservation },
      workerClientFactory: (scenario) =>
        new SimWorkerClient(
          scenario,
          () =>
            new Worker(new URL('./simWorker.ts', import.meta.url), {
              type: 'module',
            }) as WorkerLike,
        ),
      rafScheduler: (callback) => requestAnimationFrame(callback),
      now: () => performance.now(),
      getGamepads: () => Array.from(navigator.getGamepads()),
      renderer,
    });
    mount.replaceChildren(shell.root);
  } catch (error) {
    mount.textContent = error instanceof Error ? error.message : String(error);
  }
}
